import { Box, Button, TextField, Typography } from "@mui/material";
import { SubscriptionHeaderBox } from "./styles";
import { TopContainer, styles } from "./styles";
import { useContext, useState } from "react";
import { AuthContext, UserDetailsContext } from "../../contexts";
import { SubscriptionPlans } from "../../components/SubscriptionPlans/SubscriptionPlans";
import { useGetCustomerPortalLink } from "../../hooks/useGetCustomerPortalLink";
import { submitPromoCode } from "../../services/promoCodeService";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { PostPromotionCodeResponse } from "../../proto/api_pb";
import { toast } from "react-toastify";
import { RpcError, StatusCode } from "grpc-web";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "../Loading";
import { tierMap } from "./types";
import { MobileScreenBottomNavigationContainer } from "../Tracks/styles";
import { MobileScreenBottomNavigation } from "../../components/TracksPageComponents/MobileScreenBottomNavigation";
import { MobileDrawer } from "../../components/MobileDrawer/MobileDrawer";

const Billing: React.FC = () => {
  const [promoCode, setPromoCode] = useState<string>("");
  const { subscriptionTier } = useContext(UserDetailsContext);
  const { userId } = useContext(AuthContext);
  const { getValidAccessToken } = useGetValidAccessToken();
  const { getCustomerPortalLink } = useGetCustomerPortalLink();

  const handleSubmitPromotionCode = async () => {
    const accessToken = await getValidAccessToken();
    const response = await submitPromoCode(accessToken, userId, promoCode);
    if (response instanceof PostPromotionCodeResponse) {
      console.log(response);
      toast.success("Promo code applied successfully");
    } else if (response instanceof RpcError) {
      if (response?.code === StatusCode.NOT_FOUND) {
        toast.error("Promo code not found");
      } else if (response?.code === StatusCode.INVALID_ARGUMENT) {
        toast.error("Error applying promo code");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  return (
    <>
      <MobileDrawer />
      <Box sx={{ display: "flex" }}>
        <Box sx={styles.billingContainer}>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            Billing
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", marginTop: "10px" }}
          >
            Simple, transparent pricing
          </Typography>
          <Typography sx={{ marginTop: "10px" }}>
            You are subscribed to OmMuse {tierMap[subscriptionTier]}
          </Typography>
          <Box sx={styles.billingPageContainer}>
            <Box sx={styles.paymentComponentContainer}>
              <Box>
                <TopContainer>
                  <SubscriptionHeaderBox>
                    <Button
                      onClick={getCustomerPortalLink}
                      variant="contained"
                      sx={styles.billingButton}
                    >
                      Change Plan
                    </Button>
                    <Button
                      variant="contained"
                      onClick={getCustomerPortalLink}
                      sx={styles.billingButton}
                    >
                      Update Payment Method
                    </Button>
                    <Button
                      variant="contained"
                      onClick={getCustomerPortalLink}
                      sx={styles.billingButton}
                    >
                      Billing History
                    </Button>
                    <TextField
                      sx={styles.promoCodeInput}
                      placeholder="Apply Promo"
                      onChange={(e) => setPromoCode(e.target.value)}
                      id="outlined-basic"
                      variant="outlined"
                    />
                    <Button
                      onClick={handleSubmitPromotionCode}
                      variant="contained"
                      sx={styles.submitButton}
                    >
                      Apply
                    </Button>
                    <Box sx={{ display: "flex", alignItems: "center " }}></Box>
                  </SubscriptionHeaderBox>
                </TopContainer>
                <hr />
                <SubscriptionPlans />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <MobileScreenBottomNavigationContainer>
        <MobileScreenBottomNavigation />
      </MobileScreenBottomNavigationContainer>
    </>
  );
};

export default withAuthenticationRequired(Billing, {
  onRedirecting: () => <Loading />,
});
